import React, {Fragment} from 'react';
import './dropdown.scss';
import ReactDOM from 'react-dom';
import { Menu } from 'semantic-ui-react'
import {Link, withRouter} from "react-router-dom";

function MenuItem(props) {
	const {title, childrenMenus = [], url, history} = props;

	function ChildMenu() {
		if (childrenMenus.length > 0) {
			return (
				childrenMenus.map(item => (
					<Menu.Item
						className='dropdown-item dropdown-sub-item standard-header'
						onMouseDown={() => {
							history.push(item.url);
						}}
					>
						&nbsp;&nbsp;&nbsp;&nbsp;<span dangerouslySetInnerHTML={{__html: item.title}}/>
					</Menu.Item>
				))
			);
		} else {
			return null;
		}
	}
	return (
		<Fragment>
			<Menu.Item
				className='dropdown-item standard-header'
				onMouseDown={() => {
					history.push(url);
				}}
			>
				<span dangerouslySetInnerHTML={{__html: title}}/>
			</Menu.Item>
			<ChildMenu />
		</Fragment>
	);
}

export default withRouter(class CustomDropdown extends React.Component {
	constructor() {
		super();
		this.state = {
			open: false
		};
		this.itemRef = React.createRef();
	}

	handleOnClick = () => {
		this.setState({
			...this.state,
			open: !this.state.open
		});
	};

	handleOnBlur = () => {
		this.setState({
			...this.state,
			open: false
		});
	};

	generateStyle = () => {
		const node = this.itemRef.current;
		if (node) {
			return {
				top: ReactDOM.findDOMNode(node).getBoundingClientRect().height
			};
		} else {
			return {};
		}
	};

	render() {
		const {
				  items,
				  title,
				history
			  } = this.props;

		return (
			<Menu.Item
				className="a-dropdown standard-header"
				onClick={this.handleOnClick}
				ref={this.itemRef}
				onBlur={this.handleOnBlur}
				tabIndex={-1}
			>
				<span dangerouslySetInnerHTML={{__html: title}}/>
				{this.state.open &&
					<Menu vertical inverted className='dropdown-content' style={this.generateStyle()}>
						{items.sort((a, b) => a.order - b.order).map(item =>
							<MenuItem {...item} history={history} />
						)}
					</Menu>
				}
			</Menu.Item>
		)
	};
})


// WEBPACK FOOTER //
// ./src/modules/Dropdown/index.js